// sessionStorage key holding the internal referral id awaiting Healthlink
// Integrated Browser confirmation across the auto-redirect round trip.
// HealthLink drops our redirectUrl query params (it returns only its own
// ?controlId), so we carry our own id here — it survives the same-tab
// navigation and is read back on return.
export const PENDING_IB_REFERRAL_KEY = "kinesin-ib-pending-referral-id";
